module.exports = __webpack_public_path__ + "img/square-ellipsis-vertical.75fdc7bb.svg";